import { render, staticRenderFns } from "./header-notification.vue?vue&type=template&id=470bcedf"
import script from "./header-notification.vue?vue&type=script&lang=js"
export * from "./header-notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports